import { PointOfSaleSharp, ReceiptSharp, SearchSharp, Close, ArrowBackIosNew, AssignmentReturnOutlined, Inventory2Outlined, ConfirmationNumberOutlined } from '@mui/icons-material';
import { Box, Button, LinearProgress, Typography, useMediaQuery, useTheme, Stepper, Step, StepLabel, Paper, Avatar, Chip, Divider, IconButton, Alert, Checkbox, FormControlLabel, Switch } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Modal, Search, CircularProgressCustom, NewSale, CashRegister, NumberInputDialog, FormPaymentType, CustomSnackbars } from '../../components';
import Sales from '../../components/Table/Mobile/Sales';
import { useMiContexto } from '../../components/base/ContextProvider';
import { useCurrentUser } from '../../components/base/UserProvider';
import TabsSales from '../../components/sales/TabsSales';
import { OPERATION, STATUS_SALE, TYPE_MOVEMENT } from '../../helpers/enums';
import SaleService from '../../services/sales';
import UserService from '../../services/user';
import RaffleService from '../../services/raffle';
import ArticuloService from '../../services/articulos';
import MovementService from '../../services/movements';
import StoreService from '../../services/stores';
import PaymentTypesService from '../../services/paymentTypes';
import PrinterService from '../../services/printer';
import SalesView from './SalesView';
import VentasView from './VentasView';
import ReturnSale from '../../components/Table/Mobile/ReturnSale';
import StockMovement from '../../components/Table/Mobile/StockMovement';
import RaffleStandaloneSaleDialog from '../../components/sales/RaffleStandaloneSaleDialog';
import StoreCreditsPanel from '../../components/sales/StoreCreditsPanel';
import StoreCreditService from '../../services/storeCredits';
import { STATUS_STORE_CREDIT } from '../../helpers/enums';

// import API from '../../config/config';
// import axios from 'axios';

const SearchSalesView = ({ store, salesData = [], readonly = true, onSearchSales, groupByDate, users, hanldeCompleteOrders, onDeliverGroup, onDeleteItem, onMergePendingSales, onAddDeposit, onAddItems, onCancelGroup, onAssignRaffle, raffleMinimo, onUpdateHeld, cashierMode = false, onlyTodayPending = false }) => {
  const [buttonSelected, setButtonSelected] = useState(STATUS_SALE.FINISHED);
  const [loading, setLoading] = useState(false);
  const [tabSelected, setTabSelected] = useState(2);
  const [salesByStatus, setSalesByStatus] = useState({});
  const [showHeldFinished, setShowHeldFinished] = useState(false);

  const getTodayLocalDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    console.log("Botón seleccionado:", buttonSelected);
  }, [buttonSelected]);

  const handleSearch = async ({ searchQuery }, status) => {
    setLoading(true)
    let query
    if (status === 'held') {
      query = [`name=${searchQuery || ''}`, `held=true`]
    } else {
      query = [`name=${searchQuery || ''}`, `status=${status}`]
      if (cashierMode && status === STATUS_SALE.RESERVED && onlyTodayPending) {
        query.push(`date=${getTodayLocalDate()}`)
      }
    }
    var resp = await SaleService.searchSales(store._id, query.join('&'))
    setSalesByStatus(prev => ({ ...prev, [status]: resp }));
    if (status === STATUS_SALE.RESERVED && showHeldFinished) {
      const hfResp = await SaleService.searchSales(store._id, `name=${searchQuery || ''}&status=${STATUS_SALE.FINISHED}&held=true`)
      setSalesByStatus(prev => ({ ...prev, held_finished: hfResp }))
    }
    setLoading(false)
  }

  const reloadStatus = async (status) => {
    setLoading(true)
    try {
      let query
      if (status === 'held') {
        query = [`name=`, `held=true`]
      } else {
        query = [`name=`, `status=${status}`]
        if (cashierMode && status === STATUS_SALE.RESERVED && onlyTodayPending) {
          query.push(`date=${getTodayLocalDate()}`)
        }
      }
      const resp = await SaleService.searchSales(store._id, query.join('&'))
      setSalesByStatus((prev) => ({ ...prev, [status]: resp }))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const statusByTab = [STATUS_SALE.FINISHED, STATUS_SALE.CANCELED, STATUS_SALE.RESERVED]
    const statusToLoad = statusByTab[tabSelected] || STATUS_SALE.RESERVED

    // Only auto-load pending sales when opening/changing tabs.
    if (statusToLoad !== STATUS_SALE.RESERVED) {
      return
    }

    const loadByStatus = async () => {
      setLoading(true)
      try {
        let query
        query = [`name=`, `status=${statusToLoad}`]
        if (cashierMode && statusToLoad === STATUS_SALE.RESERVED && onlyTodayPending) {
          query.push(`date=${getTodayLocalDate()}`)
        }
        const resp = await SaleService.searchSales(store._id, query.join('&'))
        setSalesByStatus((prev) => ({ ...prev, [statusToLoad]: resp }))
      } finally {
        setLoading(false)
      }
    }

    if (store?._id) {
      loadByStatus()
    }
  }, [tabSelected, store?._id, cashierMode, onlyTodayPending])

  const loadHeldFinished = async () => {
    setLoading(true)
    try {
      const query = `name=&status=${STATUS_SALE.FINISHED}&held=true`
      const resp = await SaleService.searchSales(store._id, query)
      setSalesByStatus(prev => ({ ...prev, held_finished: resp }))
    } finally {
      setLoading(false)
    }
  }

  const handleToggleHeldFinished = (checked) => {
    setShowHeldFinished(checked)
    if (checked) {
      loadHeldFinished()
    } else {
      setSalesByStatus(prev => ({ ...prev, held_finished: [] }))
    }
  }

  const SaleComponent = ({status, tittle}) => {
    const baseData = salesByStatus[status] || [];
    const dataForStatus = status === STATUS_SALE.RESERVED && showHeldFinished
      ? [...baseData, ...(salesByStatus['held_finished'] || [])]
      : baseData;

    return (
      <Box
        sx={{
          bgcolor: '#fcf8f2',
          borderRadius: 2,
          backgroundImage: 'linear-gradient(180deg, #fdfaf6 0%, #f7efe4 100%)',
          px: { xs: 0.5, sm: 0.75 },
          py: { xs: 0.25, sm: 0.4 },
        }}
      >
      <Typography margin={1}>{`Pedidos: En esta pantalla se visualizan pedidos ${tittle}`}</Typography>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Search onSearch={(query) => handleSearch(query, status)} width='100%'/>
        {status === STATUS_SALE.RESERVED && cashierMode && (
          <FormControlLabel
            sx={{ ml: 1, mr: 0, whiteSpace: 'nowrap' }}
            control={
              <Switch
                size='small'
                checked={showHeldFinished}
                onChange={(e) => handleToggleHeldFinished(e.target.checked)}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': { color: '#3949ab' },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#3949ab' },
                }}
              />
            }
            label={
              <Box display='flex' alignItems='center' gap={0.5}>
                <Inventory2Outlined sx={{ fontSize: 14, color: '#3949ab' }} />
                <Typography variant='caption' sx={{ color: '#3949ab', fontWeight: 600, fontSize: '0.68rem' }}>Depósito</Typography>
              </Box>
            }
          />
        )}
      </Box>
      {loading && <CircularProgressCustom color='secondary' />}
      <Box
        display='flex'
        flexDirection='column'
        justifyContent='space-between'
        width='100%'
        flex='1'
        padding={2}
      >
        {!loading && <Sales
          users={users}
          readonly={readonly}
          salesData={dataForStatus}
          onCompleteSales={hanldeCompleteOrders}
          onDeleteItem={status === STATUS_SALE.RESERVED
            ? async (sale, salesGroup) => {
              if (!onDeleteItem) return
              await onDeleteItem(sale, salesGroup)
              await reloadStatus(status)
            }
            : undefined}
          onDeliverGroup={status === STATUS_SALE.RESERVED
            ? async (selectedSales = [], heldUpdates = []) => {
              if (!selectedSales.length) return
              if (onDeliverGroup) {
                await onDeliverGroup(selectedSales, heldUpdates)
              } else {
                await hanldeCompleteOrders(STATUS_SALE.FINISHED, selectedSales)
                if (heldUpdates.length && onUpdateHeld) {
                  await onUpdateHeld(heldUpdates)
                }
              }
            }
            : undefined
          }
          visualVariant={cashierMode ? 'cashier' : 'default'}
          groupByDate={groupByDate}
          onMergePendingSales={status === STATUS_SALE.RESERVED ? onMergePendingSales : undefined}
          onAddDeposit={status === STATUS_SALE.RESERVED ? onAddDeposit : undefined}
          onAddItems={status === STATUS_SALE.RESERVED ? onAddItems : undefined}
          onCancelGroup={status === STATUS_SALE.RESERVED ? onCancelGroup : undefined}
          onAssignRaffle={status === STATUS_SALE.RESERVED ? onAssignRaffle : undefined}
          raffleMinimo={raffleMinimo}
          onUpdateHeld={onUpdateHeld
            ? async (updates) => {
                await onUpdateHeld(updates)
                await reloadStatus(status)
                if (status === STATUS_SALE.RESERVED && showHeldFinished) {
                  await loadHeldFinished()
                }
              }
            : undefined}
          enablePendingMergeDrag={status === STATUS_SALE.RESERVED}
          showPaidWatermark={status === STATUS_SALE.RESERVED && showHeldFinished}
        />}
      </Box>
    </Box>
    )
  }

  const options = [
    { tittle: 'Finalizadas', disabled: false, Content: () => <SaleComponent status={STATUS_SALE.FINISHED} tittle={'Completados'} />},
    { tittle: 'Canceladas', disabled: false, Content: () => <SaleComponent status={STATUS_SALE.CANCELED} tittle={'Cancelados'} /> },
    { tittle: 'Pendientes', disabled: false, Content: () => <SaleComponent status={STATUS_SALE.RESERVED} tittle={'Pendientes'} />},
  ]

  return <>
    <TabsSales
      positionTab='top'
      colorBackground="#FFF8FB"
      tabSelected={tabSelected}
      onTabSelected={setTabSelected}
      options={options}
    />
  </>
}

const Ventas = ({ store, setOptions, setChildHeader, cashierMode = false }) => {
  const [onlyTodayPendingCashier, setOnlyTodayPendingCashier] = useState(false);
  const [openRaffleStandaloneModal, setOpenRaffleStandaloneModal] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


  const [status, setStatus] = useState(STATUS_SALE.FINISHED);
  const [tabSelected, setTabSelected] = useState(0);
  const [dateSelected, setDateSelected] = useState(new Date());
  const tabSelectedRef = useRef(tabSelected);
  const dateSelectedRef = useRef(dateSelected);
  const statusSelectedRef = useRef(status);
  const { miValor, setValor } = useMiContexto();
  const { isAdmin, currentUser } = useCurrentUser();
  const [saving, setSaving] = useState(false);
  const [loadsSalesReserved, setLoadsSalesReserved] = useState(true);
  const [loadsSalesReserved2, setLoadsSalesReserved2] = useState([]);
  const [salesReserved, setSalesReserved] = useState([]);
  const [salesReserved2, setSalesReserved2] = useState([]);
  const [loadingSalesReserved, setLoadingSalesReserved] = useState(false);
  const [loadingSalesReserved2, setLoadingSalesReserved2] = useState(false);
  const [loadsSales, setLoadsSales] = useState(true);
  const [sales, setSales] = useState([]);
  const [loadingSales, setLoadingSales] = useState(false);
  const [users, setUsers] = useState([])
  const [loadingArticulos, setLoadingArticulos] = useState(false);
  const [articulos, setArticulos] = useState([]);
  const [newSaleName, setNewSaleName] = useState('');
  const [newSaleExistingItems, setNewSaleExistingItems] = useState([]);
  const [cashRegister, setCashRegister] = useState(null);
  const [openCashRegister, setOpenCashRegister] = useState(false);
  const [loadingCashRegister, setLoadingCashRegister] = useState(false);
  const [openReturnFlow, setOpenReturnFlow] = useState(false);
  const [returnStep, setReturnStep] = useState('search');
  const [returnArticles, setReturnArticles] = useState([]);
  const [loadingReturnArticles, setLoadingReturnArticles] = useState(false);
  const [returnArticleSelected, setReturnArticleSelected] = useState(null);
  const [returnMovements, setReturnMovements] = useState([]);
  const [loadingReturnMovements, setLoadingReturnMovements] = useState(false);
  const [loadingMoreReturnMovements, setLoadingMoreReturnMovements] = useState(false);
  const [returnMovementsPage, setReturnMovementsPage] = useState(1);
  const [returnMovementsHasMore, setReturnMovementsHasMore] = useState(false);
  const [returnSaleSelected, setReturnSaleSelected] = useState(null);
  const [returnAsCredit, setReturnAsCredit] = useState(true);
  const [openStoreCreditsModal, setOpenStoreCreditsModal] = useState(false);
  const [hasStoreCredits, setHasStoreCredits] = useState(false);
  const [returnCreditFeedback, setReturnCreditFeedback] = useState(null);
  const [deliverPaymentModal, setDeliverPaymentModal] = useState({ open: false, selectedSales: [], payments: [], heldUpdates: [] });
  const [activeLoteMinimo, setActiveLoteMinimo] = useState(0);
  const [hasActiveRaffle, setHasActiveRaffle] = useState(false);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const isCashRegisterOpen = cashRegister?.status === "OPENED" || isAdmin;

  const mapPaymentTypesToForm = (items = []) =>
    (items || []).map((pt) => ({
      _id: pt?._id,
      name: pt?.name || 'Medio de pago',
      description: pt?.description || '',
      applies_surcharge: Boolean(pt?.applies_surcharge),
      installments: Array.isArray(pt?.installments) ? pt.installments : [],
      amount: 0,
    }));

  const createPaymentTemplate = () => structuredClone(paymentTypes);
  const paymentTypeKey = (paymentType = {}) => paymentType?._id || paymentType?.name;

  const loadUsers = async () => {
    var resp = await UserService.getAll()
    var respFiltered = resp.filter(u => u.name !== '' && u.name !== 'Diego Cesar')
    setUsers(respFiltered)
  }

  const loadCashRegister = async () => {
    var resp = await SaleService.getCurrentCashRegister(store._id)
    // if (resp !== null) {
    //   var ventas = await getVentas()
    //   if (ventas) {
    //     var cs = {
    //       ...cashRegister,
    //       detail_cash_register: {
    //         ...cashRegister.detail_cash_register,
    //         cash_sale_total: ventas.efectivo,
    //         trans_sale_total: ventas.transferencia,
    //       }
    //     }
    //   }
    //   setCashRegister(cs)
    // }
    setCashRegister(resp)
  }

  useEffect(() => {
    if (users.length === 0) {
      loadUsers()
    }
    if (cashRegister === null) {
      loadCashRegister()
    }
    RaffleService.getLotes().then((lotes) => {
      const active = (lotes || []).find((l) => l.activo)
      setHasActiveRaffle(Boolean(active))
      setActiveLoteMinimo(active?.config?.monto_minimo ?? 0)
    }).catch(() => {
      setHasActiveRaffle(false)
      setActiveLoteMinimo(0)
    })
  }, [])

  useEffect(() => {
    if (!store?._id) return

    StoreCreditService.getAll(store._id, undefined, undefined, 1, 1)
      .then((resp) => {
        const credits = Array.isArray(resp?.items) ? resp.items : (Array.isArray(resp) ? resp : [])
        setHasStoreCredits(Number(resp?.total ?? credits.length) > 0)
      })
      .catch(() => setHasStoreCredits(false))
  }, [store?._id])

  useEffect(() => {
    if (!store?._id) return
    const controller = new AbortController()

    const loadPaymentTypes = async () => {
      try {
        const response = await PaymentTypesService.listByStore(store._id, { signal: controller.signal })
        if (controller.signal.aborted) return
        setPaymentTypes(mapPaymentTypesToForm(Array.isArray(response) ? response : []))
      } catch (err) {
        if (err?.name === 'CanceledError' || err?.name === 'AbortError') return
        console.error('Error loading payment types:', err)
        setPaymentTypes([])
      }
    }

    loadPaymentTypes()
    return () => controller.abort()
  }, [store?._id])

  useEffect(() => {
    if (!store?._id) return

    const unsubscribe = PaymentTypesService.subscribeToChanges(async ({ storeId }) => {
      if (storeId && storeId !== store._id) return
      try {
        const response = await PaymentTypesService.listByStore(store._id, { forceRefresh: true })
        setPaymentTypes(mapPaymentTypesToForm(Array.isArray(response) ? response : []))
      } catch (err) {
        console.error('Error refreshing payment types:', err)
      }
    })

    return () => unsubscribe()
  }, [store?._id])

  const loadSalesReserved = async () => {
    setLoadingSalesReserved(true)
    var resp = await SaleService.getAll(store._id, [STATUS_SALE.RESERVED], dateSelected)
    setSalesReserved(resp)
    setLoadsSalesReserved(false)
    setLoadingSalesReserved(false)
  }

  const loadSalesReserved2 = async (stat) => {
    setLoadingSalesReserved2(true)
    var resp = await SaleService.getAll(store._id, [stat], "")
    setSalesReserved2(resp)
    // setLoadsSalesReserved2(false)
    setLoadingSalesReserved2(false)
  }

  const loadSales = async () => {
    setLoadingSales(true)
    var resp = await SaleService.getAll(store._id, [STATUS_SALE.CANCELED, STATUS_SALE.FINISHED, STATUS_SALE.RETURNED], dateSelected)
    //var respFinished = await SaleService.getAll(store._id, STATUS_SALE.FINISHED, dateSelected)
    setSales(resp)
    setLoadsSales(false)
    setLoadingSales(false)
  }

  useEffect(() => {
    if (loadsSalesReserved && miValor) {
      loadSalesReserved()
    }
  }, [loadsSalesReserved, miValor])

  useEffect(() => {
    if (loadsSales && miValor) {
      loadSales()
    }
  }, [loadsSales, miValor])

  useEffect(() => {
    tabSelectedRef.current = tabSelected; // Actualizar el valor de la referencia cuando cambia `tabSelected`
  }, [tabSelected])

  useEffect(() => {
    dateSelectedRef.current = dateSelected; // Actualizar el valor de la referencia cuando cambia `tabSelected`
  }, [dateSelected])

  useEffect(() => {
    setOptions && setOptions(null)
    if (cashierMode) {
      setChildHeader && setChildHeader(null)
      return
    }

    setChildHeader && setChildHeader(<Box display='flex' flexDirection='row' width={'100%'}>
      <Search onSearch={handleChangeDate} />
    </Box>)
  }, [])

  // useEffect(() => {
  //   statusSelectedRef.current = status
  //   loadSalesReserved2()
  // }, [status])

  const handleChangeDate = async ({ date, searchQuery }) => {
    console.log("tabbb" + tabSelectedRef.current)
    if (!isMobile) {
      setLoadingSales(true)
      setLoadingSalesReserved(true)
      var resp = await SaleService.searchSales(store._id, `date=${dateSelectedRef.current}&name=${searchQuery}&status=${STATUS_SALE.FINISHED}`)
      var resp2 = await SaleService.searchSales(store._id, `date=${dateSelectedRef.current}&name=${searchQuery}&status=${STATUS_SALE.RESERVED}`)
      console.log(resp)
      console.log(resp2)
      setSales(resp)
      setSalesReserved(resp2)
      setLoadingSales(false)
      setLoadingSalesReserved(false)
    } else {
      switch (tabSelectedRef.current) {
        case 0:
          setLoadingSales(true)
          var resp = await SaleService.searchSales(store._id, `date=${dateSelectedRef.current}&name=${searchQuery}&status=${STATUS_SALE.FINISHED}`)
          console.log(resp)
          setSales(resp)
          setLoadingSales(false)
          break;
        case 1:
          setLoadingSalesReserved(true)
          var resp = await SaleService.searchSales(store._id, `date=${dateSelectedRef.current}&name=${searchQuery}&status=${STATUS_SALE.RESERVED}`)
          console.log(resp)
          setSalesReserved(resp)
          setLoadingSalesReserved(false)
          break;
        case 2:
          setLoadingSalesReserved2(true)
          var response = await SaleService.searchSales(store._id, `date=${""}&name=${searchQuery}&status=${statusSelectedRef.current}`)
          console.log(response)
          setSalesReserved2(response)
          setLoadingSalesReserved2(false)
          break;
        default:
          break;
      }
    }
  }

  const hanldeCompleteOrders = async (status, salesChecked, payments) => {
    if (!isCashRegisterOpen) {
      return
    }

    setSaving(true)
    setStatus(status)

    // A vale is a discount on the sale total, applied once on the first matched sale of its group.
    if (Array.isArray(payments) && payments.length) {
      payments.forEach((payment) => {
        if (!payment.credit?.code || !payment.credit?.amount) return
        const matchedSale = salesChecked.find(sale => !payment.saleIds || payment.saleIds.includes(sale._id))
        if (matchedSale) {
          matchedSale.store_credit_applied = { code: payment.credit.code, amount: payment.credit.amount }
        }
      })
    }

    var resp = await SaleService.updateStatus(store._id, status, salesChecked)
    setSalesReserved([])
    setSales([])
    setLoadsSales(true)
    setLoadsSalesReserved(true)

    setSaving(false)
    return resp
  }

  const deleteSaleSelected = async (saleToDelete, salesGroupParam) => {
    if (!isCashRegisterOpen) {
      return
    }

    if (saleToDelete) {
      console.log(salesGroupParam)
      salesGroupParam.sales = salesGroupParam.sales.filter(s => s._id !== saleToDelete._id)
      await SaleService.updateStatus(store._id, STATUS_SALE.CANCELED, [saleToDelete])
      setLoadsSales(true)
      setLoadsSalesReserved(true)
      setLoadsSalesReserved2(true)
    }
  }

  const reserveSaleSelected = async (saleToReserve) => {
    if (!isCashRegisterOpen) {
      return
    }

    if (saleToReserve) {
      console.log(saleToReserve)
      // salesGroup.sales = salesGroup.sales.filter(s => s._id !== saleCancel._id)
      // await SaleService.updateStatus(store._id, STATUS_SALE.CANCELED, [saleCancel])
    }
  }

  const handleAddDeposit = async ({ nameSale, amount }) => {
    if (!isCashRegisterOpen) return
    setSaving(true)
    try {
      await SaleService.addDeposit(store._id, nameSale, amount)
      setLoadsSalesReserved(true)
      setLoadsSalesReserved2(true)
    } finally {
      setSaving(false)
    }
  }

  const handleMergePendingSales = async ({ sourceSales = [], targetSales = [], selectedName }) => {
    if (!isCashRegisterOpen) {
      return
    }

    if (!selectedName) return

    const allSales = [...sourceSales, ...targetSales]
    const salesToRename = allSales.filter((sale) => sale?.nameSale !== selectedName)

    if (!salesToRename.length) {
      return
    }

    setSaving(true)
    try {
      await Promise.all(
        salesToRename.map((sale) => SaleService.updateName(store._id, sale._id, selectedName))
      )
      setLoadsSalesReserved(true)
    } finally {
      setSaving(false)
    }
  }

  const buildDeliverPayments = (selectedSales = []) => {
    const pendingTotal = selectedSales.reduce((sum, sale) => {
      const total = Number(sale?.quantity_sold || 0) * Number(sale?.prices_sold?.sale_price || 0)
      const deposit = Number(sale?.deposit || 0)
      return sum + Math.max(total - deposit, 0)
    }, 0)

    return {
      pendingTotal,
      payments: [{
        saleIds: selectedSales.map((sale) => sale._id),
        nameSale: selectedSales[0]?.nameSale || 'Venta',
        total: pendingTotal,
        amount: 0,
        paymenttypes: createPaymentTemplate(),
      }],
    }
  }

  const distributePaymentsBySale = (selectedSales = [], payments = []) => {
    const safePayments = Array.isArray(payments) ? payments : []

    const distributionByGroup = safePayments.reduce((acc, groupPayment) => {
      const saleIds = groupPayment?.saleIds || []
      if (!saleIds.length) return acc

      const types = Array.isArray(groupPayment?.paymenttypes) ? groupPayment.paymenttypes : []
      const remainingByType = types.reduce((typeAcc, p) => {
        const key = paymentTypeKey(p)
        if (!key) return typeAcc
        typeAcc[key] = Number(p?.amount || 0)
        return typeAcc
      }, {})

      acc[saleIds.join('|')] = {
        saleIds,
        typeOrder: types.map((p) => paymentTypeKey(p)).filter(Boolean),
        remainingByType,
        paymentsTemplate: types.map((p) => ({ ...p, amount: 0 })),
      }

      return acc
    }, {})

    return selectedSales.map((sale) => {
      const saleTotal = Number(sale?.quantity_sold || 0) * Number(sale?.prices_sold?.sale_price || 0)
      const deposit = Number(sale?.deposit || 0)
      const pending = Math.max(saleTotal - deposit, 0)

      const groupKey = Object.keys(distributionByGroup).find((key) => distributionByGroup[key].saleIds.includes(sale._id))
      const group = groupKey ? distributionByGroup[groupKey] : null

      const paymentsBySale = group
        ? structuredClone(group.paymentsTemplate)
        : createPaymentTemplate()

      if (!group || pending <= 0) {
        return { ...sale, payments: paymentsBySale }
      }

      let remainingPending = pending

      group.typeOrder.forEach((typeKey) => {
        if (remainingPending <= 0) return
        const remainingTypeAmount = Number(group.remainingByType[typeKey] || 0)
        if (remainingTypeAmount <= 0) return

        const assigned = Math.min(remainingTypeAmount, remainingPending)
        group.remainingByType[typeKey] = remainingTypeAmount - assigned
        remainingPending -= assigned

        const paymentIndex = paymentsBySale.findIndex((p) => paymentTypeKey(p) === typeKey)
        if (paymentIndex >= 0) {
          paymentsBySale[paymentIndex].amount = assigned
        }
      })

      return {
        ...sale,
        payments: paymentsBySale,
      }
    })
  }

  const handleCloseDeliverPaymentModal = () => {
    if (saving) return
    setDeliverPaymentModal({ open: false, selectedSales: [], payments: [], heldUpdates: [] })
  }

  const getSavedSaleIds = (savedSales = []) => {
    const salesArray = Array.isArray(savedSales) ? savedSales : [savedSales]
    return Array.from(new Set(
      salesArray
        .map((sale) => sale?.idSale || sale?._id || sale?.id || sale?.saleId)
        .filter(Boolean)
    ))
  }

  const printDeliveredSales = async (savedSales = []) => {
    const ids = getSavedSaleIds(savedSales)
    if (!ids.length) return

    const activePrinter = await PrinterService.getActivePrinter()
    if (activePrinter?.printerType === 'pdf') {
      await PrinterService.downloadTicketPreviewAsPDF(store._id, ids.join(','))
    } else {
      await PrinterService.printSales(store._id, ids)
    }
  }

  const handleConfirmDeliverWithPayments = async ({ payments } = {}) => {
    const selectedSales = deliverPaymentModal.selectedSales || []
    const heldUpdates = deliverPaymentModal.heldUpdates || []
    if (!selectedSales.length) return

    const distributedSales = distributePaymentsBySale(selectedSales, payments)
    const savedSales = await hanldeCompleteOrders(STATUS_SALE.FINISHED, distributedSales, payments)

    if (heldUpdates.length) {
      await handleUpdateHeld(heldUpdates)
    }
    if (savedSales !== undefined) {
      try {
        await printDeliveredSales(distributedSales)
      } catch {

      } finally {
        setDeliverPaymentModal({ open: false, selectedSales: [], payments: [], heldUpdates: [] })
      }
    }
    setDeliverPaymentModal({ open: false, selectedSales: [], payments: [], heldUpdates: [] })
  }

  const handleDeliverGroupFromCashier = async (selectedSales = [], heldUpdates = []) => {
    if (!isCashRegisterOpen) return
    if (!selectedSales.length) return

    const { pendingTotal, payments } = buildDeliverPayments(selectedSales)
    if (!paymentTypes.length) {
      return
    }
    if (pendingTotal > 0) {
      setDeliverPaymentModal({ open: true, selectedSales, payments, heldUpdates })
      return
    }

    const savedSales = await hanldeCompleteOrders(STATUS_SALE.FINISHED, selectedSales)
    if (heldUpdates.length) {
      await handleUpdateHeld(heldUpdates)
    }
    if (savedSales !== undefined) {
      try {
        await printDeliveredSales(savedSales)
      } catch {

      }
    }
  }

  const handleRefreshDailySales = async () => {
    await Promise.all([
      loadSales(),
      loadSalesReserved(),
    ])
  }

  const options = [
    { tittle: 'Ventas', icon: <PointOfSaleSharp />, disabled: false, Content: () => 
      <SalesView
        key='ventas'
        salesData={sales}
        readonly
        users={users}
        onChangeDate={!cashierMode ? ((date) => {
          setDateSelected(date)
          setLoadsSales(true)
          setLoadsSalesReserved(true)
        }) : undefined}
        onCompleteOrders={hanldeCompleteOrders}
        onRefresh={handleRefreshDailySales}
        loadingSales={loadingSales}
        date={dateSelected}
        showCalendar={!cashierMode}
        visualVariant={cashierMode ? 'cashier' : 'default'}
        onlyTodayPending={onlyTodayPendingCashier}
      />
    },
    { tittle: 'Reservas', icon: <ReceiptSharp />, disabled: false, Content: () =>
      <VentasView 
        salesReserved={salesReserved}
        loading={loadingSalesReserved}
        saving={saving}
        users={users}
        paymentTypes={paymentTypes}
        storeId={store?._id}
        onDeleteItem={deleteSaleSelected}
        onReserveItem={reserveSaleSelected}
        onCompleteSales={hanldeCompleteOrders}
        onAddDeposit={isCashRegisterOpen ? handleAddDeposit : undefined}
        onAddItems={isCashRegisterOpen ? handleAddItems : undefined}
        readonly={!isCashRegisterOpen}
      />
    },
    {
      tittle: 'Buscar', icon: <SearchSharp />, disabled: false, Content: () =>
        <SearchSalesView
          store={store}
          readonly={!isCashRegisterOpen}
          key='ventas'
          loading={loadingSalesReserved2}
          users={users}
          cashierMode={cashierMode}
          onlyTodayPending={onlyTodayPendingCashier}
          hanldeCompleteOrders={hanldeCompleteOrders}
          onDeliverGroup={handleDeliverGroupFromCashier}
          onDeleteItem={deleteSaleSelected}
          onMergePendingSales={handleMergePendingSales}
          onAddDeposit={isCashRegisterOpen ? handleAddDeposit : undefined}
          onCancelGroup={isCashRegisterOpen ? async (groupSales) => {
            await hanldeCompleteOrders(STATUS_SALE.CANCELED, groupSales)
          } : undefined}
          onAssignRaffle={isCashRegisterOpen ? handleAssignRaffle : undefined}
          raffleMinimo={activeLoteMinimo}
          onUpdateHeld={isCashRegisterOpen ? handleUpdateHeld : undefined}
          salesData={salesReserved2}
          onSearchSales={async s => {
            setStatus(s)
            statusSelectedRef.current = s
            await loadSalesReserved2(s)
          }}
          groupByDate
        />
    },
  ]

  const visibleOptions = cashierMode
    ? options.filter((option) => option.tittle !== 'Reservas')
    : options

  const handleSearch = async ({ searchQuery }) => {
    if (!isCashRegisterOpen) {
      return
    }

    setLoadingArticulos(true)
    var resp = await ArticuloService.searchArticlesInStore(store._id, searchQuery, OPERATION.VENDER, false)
    setArticulos(resp);
    setLoadingArticulos(false);
  }

  const handleCancelSale = () => {
    setArticulos([]);
    setNewSaleName('');
    setNewSaleExistingItems([]);
  }

  const handleAddItems = (nameSale, existingItems = []) => {
    if (!isCashRegisterOpen || !nameSale) return;
    setNewSaleName(nameSale);
    setNewSaleExistingItems(existingItems);
  }

  const handleCompleteSales = async (data) => {
    if (!isCashRegisterOpen) {
      return
    }

    console.log(data)
    setSaving(true)
    try {
      const saved = await SaleService.save(store._id, data)
      setLoadsSales(true)
      setLoadsSalesReserved(true)
      setLoadsSalesReserved2(true)
      setTabSelected(0)
      setNewSaleName('')
      setNewSaleExistingItems([])
      return saved
    } catch (err) {
      throw err   // re-throw so NewSale can catch and show the error
    } finally {
      setSaving(false)
    }
  }

  const handleAssignRaffle = async ({ nameSale, numero_rifa, lote_rifa, dni, telefono }) => {
    await SaleService.assignRaffle(store._id, { nameSale, numero_rifa, lote_rifa, dni, telefono })
    setLoadsSalesReserved(true)
    setLoadsSalesReserved2(true)
  }

  const handleUpdateHeld = async (updates) => {
    await Promise.all(updates.map(({ idSale, held }) => SaleService.updateHeld(store._id, { idSale, held })))
    setLoadsSales(true)
    setLoadsSalesReserved(true)
    setLoadsSalesReserved2(true)
  }

  const handleStandaloneRaffleSaleCreated = async () => {
    setLoadsSales(true)
    setLoadsSalesReserved(true)
    setLoadsSalesReserved2(true)
  }

  const handleOpenReturnFlow = () => {
    if (!isCashRegisterOpen) {
      return
    }

    setOpenReturnFlow(true)
    setReturnArticles([])
    setReturnArticleSelected(null)
    setReturnMovements([])
    setReturnMovementsPage(1)
    setReturnMovementsHasMore(false)
    setReturnSaleSelected(null)
    setReturnAsCredit(true)
  }

  const handleCloseReturnFlow = () => {
    setOpenReturnFlow(false)
    setReturnStep('search')
    setReturnArticles([])
    setReturnArticleSelected(null)
    setReturnMovements([])
    setReturnMovementsPage(1)
    setReturnMovementsHasMore(false)
    setReturnSaleSelected(null)
    setReturnAsCredit(true)
  }

  const mapArticlesResult = (response) => {
    if (Array.isArray(response)) return response
    if (Array.isArray(response?.items)) return response.items
    if (Array.isArray(response?.data)) return response.data
    return []
  }

  const handleSearchReturnArticles = async ({ searchQuery }) => {
    if (!searchQuery || searchQuery.trim() === '') {
      setReturnArticles([])
      return
    }
    setLoadingReturnArticles(true)
    try {
      const resp = await ArticuloService.searchArticlesInStore(store._id, searchQuery.trim(), OPERATION.VENDER, false)
      setReturnArticles(mapArticlesResult(resp))
    } finally {
      setLoadingReturnArticles(false)
    }
  }

  const loadReturnMovements = async (article, options = {}) => {
    const { page = 1, append = false } = options
    const articleId = article?.article_id || article?._id
    if (!articleId) return

    if (append) {
      setLoadingMoreReturnMovements(true)
    } else {
      setLoadingReturnMovements(true)
    }

    try {
      const resp = await StoreService.searchStockMovementsPaginated(store._id, `articleId=${articleId}&page=${page}&limit=50`)
      const items = resp?.items || []
      setReturnMovements((prev) => (append ? prev.concat(items) : items))
      setReturnMovementsPage(page)
      setReturnMovementsHasMore(Boolean(resp?.hasMore))
    } finally {
      if (append) {
        setLoadingMoreReturnMovements(false)
      } else {
        setLoadingReturnMovements(false)
      }
    }
  }

  const handleSelectReturnArticle = async (article) => {
    setReturnArticleSelected(article)
    setReturnStep('history')
    await loadReturnMovements(article, { page: 1, append: false })
  }

  const handleLoadMoreReturnMovements = async () => {
    if (!returnArticleSelected || loadingMoreReturnMovements || !returnMovementsHasMore) {
      return
    }
    await loadReturnMovements(returnArticleSelected, { page: returnMovementsPage + 1, append: true })
  }

  const handleSelectReturnFromHistory = (saleMovement) => {
    setReturnSaleSelected(saleMovement)
    setReturnStep('confirm')
  }

  const handleSubmitReturnSale = async (creditName) => {
    if (!returnSaleSelected) return

    setSaving(true)
    try {
      const payload = { ...returnSaleSelected, as_credit: returnAsCredit }
      if (returnAsCredit && creditName && !payload.sale?.nameSale) {
        payload.sale = { ...payload.sale, nameSale: creditName }
      }
      await SaleService.returnSale(payload)
      setLoadsSales(true)
      setLoadsSalesReserved(true)
      setLoadsSalesReserved2(true)

      if (returnAsCredit) {
        setHasStoreCredits(true)
        const originSaleId = returnSaleSelected?.sale?._id
        try {
          const resp = await StoreCreditService.getAll(store._id, STATUS_STORE_CREDIT.PENDING)
          const pendingCredits = Array.isArray(resp?.items) ? resp.items : (Array.isArray(resp) ? resp : [])
          const credit = pendingCredits.find((c) => c.origin_sale_id === originSaleId)
          setReturnCreditFeedback(credit
            ? `Vale generado: ${credit.code} ($${credit.amount})`
            : 'Vale generado. Consultalo en el listado de vales.')
        } catch {
          setReturnCreditFeedback('Vale generado. Consultalo en el listado de vales.')
        }
      }

      setReturnSaleSelected(null)
      setReturnStep('history')
      setReturnAsCredit(true)
      if (returnArticleSelected) {
        await loadReturnMovements(returnArticleSelected, { page: 1, append: false })
      }
    } finally {
      setSaving(false)
    }
  }

  const getVentas = async (date, date2) => {
    var resp = await SaleService.searchSales(store._id, `date=${date}&dateTo=${date2}`)
    var money = resp?.reduce((item, m) => {
      if (['finalizada', 'reservada'].includes(m.status.toLowerCase())) {
        item.efectivo += m.payments ? (m.payments.find(p => p.name.toLowerCase() === 'efectivo')?.amount || 0) : 0
        item.transferencia += m.payments ? (m.payments.find(p => p.name.toLowerCase() === 'transferencia')?.amount || 0) : 0
      }
      return item
    }, { efectivo: 0, transferencia: 0 })
    return money
  }

  const getMovementTotals = async (date, date2) => {
    var resp = await MovementService.searchMovements(store._id, {
      date,
      dateTo: date2,
      type: [TYPE_MOVEMENT.GASTO, TYPE_MOVEMENT.VENTA, TYPE_MOVEMENT.DEVOLUCION]
    })

    const normalizeText = (value = '') => value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

    const isDepositMovement = (movement) => {
      if (movement?.type !== TYPE_MOVEMENT.VENTA) return false
      const description = normalizeText(movement?.description || '')
      return description.includes('sena')
    }

    return (resp || []).reduce((acc, m) => {
      if (m.type === TYPE_MOVEMENT.GASTO)     acc.gastos     += m.amount
      if (m.type === TYPE_MOVEMENT.VENTA)     acc.ingresos   += m.amount
      if (m.type === TYPE_MOVEMENT.DEVOLUCION) acc.devoluciones += m.amount
      if (isDepositMovement(m))               acc.depositos  += m.amount
      return acc
    }, { gastos: 0, ingresos: 0, devoluciones: 0, depositos: 0 })
  }

  const handleOnsaveCashRegister = async () => {
    setLoadingCashRegister(true)
    var resp = await SaleService.saveCashRegister(cashRegister)
    if (resp) {
      setCashRegister(resp)
    }
    setLoadingCashRegister(false)
    setOpenCashRegister(false)
  }

  return (
    <Box display='flex' minHeight='100%' maxWidth='100%' flexDirection='column' data-tab-content="true" position="relative">
      {(loadingSalesReserved || saving || loadingSales) && <LinearProgress color='secondary' />}
      <Box
        display='flex'
        padding={1}
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: !isMobile ? '#FBF7F2' : '#fcf8f2',
          borderBottom: '1px solid',
          borderColor: 'rgba(0,0,0,0.06)',
        }}
      >
        <Box
          display='flex'
          alignItems='center'
          gap={1}
          width='100%'
          flexWrap={{ xs: 'wrap', md: 'nowrap' }}
        >
          {isCashRegisterOpen ? (
            <>
              <NewSale
                loading={loadingArticulos}
                onSearch={handleSearch}
                articulos={articulos}
                store={store}
                users={users}
                salesReserved={salesReserved}
                onCancel={handleCancelSale}
                onCompleteSell={handleCompleteSales}
                initialName={newSaleName}
                existingItems={newSaleExistingItems}
                asModal
              />
              {cashierMode && (
                <Button
                  variant='outlined'
                  color='secondary'
                  startIcon={<ConfirmationNumberOutlined />}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    boxShadow: 3,
                  }}
                  disabled={!hasActiveRaffle}
                  onClick={() => hasActiveRaffle && setOpenRaffleStandaloneModal(true)}
                >
                  Venta rifa
                </Button>
              )}
            </>
          ) : (
            <Button variant='outlined' disabled>
              Abrí caja para operar
            </Button>
          )}
          <Button
            variant='outlined'
            color='warning'
            startIcon={<AssignmentReturnOutlined />}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              boxShadow: 3,
            }}
            disabled={!isCashRegisterOpen}
            onClick={handleOpenReturnFlow}
          >
            Devoluciones
          </Button>
          <Button
            variant='outlined'
            color='secondary'
            startIcon={<ConfirmationNumberOutlined />}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              boxShadow: 3,
            }}
            disabled={!hasStoreCredits}
            onClick={() => hasStoreCredits && setOpenStoreCreditsModal(true)}
          >
            Vales
          </Button>
          <CashRegister
            store={store}
            data={cashRegister}
            onOpenningCashRegister={async (value) => {
              setLoadingCashRegister(true)
              var cr = await SaleService.createCashRegister(value)
              if (cr) {
                setCashRegister(cr)
              }
              setLoadingCashRegister(false)
            }}
            onClossingCashRegister={(value) => {
              setCashRegister(value)
            }}
            onOpenCashRegister={async () => {
              setLoadingCashRegister(true)
              setOpenCashRegister(true)
              if (cashRegister !== null) {
                var date = new Date(cashRegister.open_at)
                var date2 = new Date()
                // date2.setDate(date.getDate() + 1)
                var [ventas, movTotals] = await Promise.all([
                  getVentas(date, date2),
                  getMovementTotals(date, date2)
                ])
                if (ventas) {
                  var cs = {
                    ...cashRegister,
                    detail_cash_register: {
                      ...cashRegister.detail_cash_register,
                      cash_sale_total: ventas.efectivo,
                      trans_sale_total: ventas.transferencia,
                      total_expenses: movTotals.gastos,
                      total_income: movTotals.ingresos,
                      total_deposits: movTotals.depositos,
                      total_refunds: movTotals.devoluciones,
                    }
                  }
                  setCashRegister(cs)
                }
              }
              setLoadingCashRegister(false)
            }}
            onCancel={() => setOpenCashRegister(false)}
            openCashRegister={openCashRegister && cashRegister !== null}
            loading={loadingCashRegister}
            onSave={handleOnsaveCashRegister}
            onCloseCashRegister={async (value) => {
              setLoadingCashRegister(true)
              const registerToClose = value || cashRegister
              const payload = {
                ...registerToClose,
                status: "CLOSED"
              }
              var resp = await SaleService.saveCashRegister(payload)
              if (resp) {
                setCashRegister(resp)
              }
              setLoadingCashRegister(false)
              setOpenCashRegister(false)
            }}
          />
          {!isCashRegisterOpen && (
            <Alert
              severity='warning'
              variant='filled'
              sx={{
                ml: { xs: 0, md: 'auto' },
                mt: { xs: 0.5, md: 0 },
                width: { xs: '100%', md: 'auto' },
                maxWidth: { md: '55%' },
                alignItems: 'center',
                py: 0.7,
                borderRadius: 2,
                fontSize: { xs: '0.83rem', md: '0.9rem' },
                fontWeight: 700,
                boxShadow: '0 4px 12px rgba(156,87,0,0.22)',
                '& .MuiAlert-message': {
                  py: 0,
                  lineHeight: 1.25,
                },
                '& .MuiAlert-icon': {
                  fontSize: { xs: 20, md: 22 },
                },
              }}
            >
              Caja cerrada: podés consultar y buscar ventas. Para operar abrí caja (F3).
            </Alert>
          )}
        </Box>
      </Box>
      <Box display='flex' flexDirection='row' flexWrap="wrap" flex='1'>
        {isMobile && !loadingSalesReserved && !saving && !loadingSales && (
          <Box width='100%' flex='1' minHeight={0} display='flex'>
            <TabsSales colorBackground="#FFF8FB" tabSelected={tabSelected} onTabSelected={setTabSelected} options={visibleOptions} />
          </Box>
        )}
        {!isMobile && <Box display='flex' flexDirection='column' width='100%' justifyContent='flex-start'>
          <Box display='flex' flexDirection='row' width='100%' height='100%' justifyContent='space-between'> 
            <SalesView 
              key='ventas'
              salesData={sales}
              readonly
              users={users}
              onChangeDate={!cashierMode ? ((date) => {
                setDateSelected(date)
                setLoadsSales(true)
                setLoadsSalesReserved(true)
              }) : undefined}
              onCompleteOrders={hanldeCompleteOrders}
                onRefresh={handleRefreshDailySales}
              loadingSales={loadingSales}
              date={dateSelected}
              showCalendar={!cashierMode}
           />
            {!cashierMode && (
              <Box width={'30%'} display='flex' flex='1'>
                <VentasView 
                  salesReserved={salesReserved}
                  loading={loadingSalesReserved}
                  saving={saving}
                  users={users}
                  onDeleteItem={deleteSaleSelected}
                  onReserveItem={reserveSaleSelected}
                  onCompleteSales={hanldeCompleteOrders}
                  onAddDeposit={isCashRegisterOpen ? handleAddDeposit : undefined}
                  onAddItems={isCashRegisterOpen ? handleAddItems : undefined}
                  readonly={!isCashRegisterOpen}
                  asList
                />    
              </Box>
            )}
            <Box width={cashierMode ? '70%' : '30%'} display='flex' flex='1'>
              <SearchSalesView
                store={store}
                readonly={!isCashRegisterOpen}
                key='ventas'
                loading={loadingSalesReserved2}
                users={users}
                cashierMode={cashierMode}
                hanldeCompleteOrders={hanldeCompleteOrders}
                onDeliverGroup={handleDeliverGroupFromCashier}
                onDeleteItem={deleteSaleSelected}
                onMergePendingSales={handleMergePendingSales}
                onAddDeposit={isCashRegisterOpen ? handleAddDeposit : undefined}
                onAddItems={isCashRegisterOpen ? handleAddItems : undefined}
                onCancelGroup={isCashRegisterOpen ? async (groupSales) => {
                  await hanldeCompleteOrders(STATUS_SALE.CANCELED, groupSales)
                } : undefined}
                onAssignRaffle={isCashRegisterOpen ? handleAssignRaffle : undefined}
                raffleMinimo={activeLoteMinimo}
                onUpdateHeld={isCashRegisterOpen ? handleUpdateHeld : undefined}
                salesData={salesReserved2}
                onSearchSales={async s => {
                  setStatus(s)
                  statusSelectedRef.current = s
                  await loadSalesReserved2(s)
                }}
                groupByDate
              />
            </Box>
          </Box>
        </Box>}
      </Box>
      <Modal
        open={deliverPaymentModal.open}
        onClose={handleCloseDeliverPaymentModal}
        width='40%'
        Content={() => (
          <Box p={2}>
            <FormPaymentType
              payments={deliverPaymentModal.payments}
              onSubmit={handleConfirmDeliverWithPayments}
              onClose={handleCloseDeliverPaymentModal}
              storeId={store?._id}
            />
          </Box>
        )}
      />
      <RaffleStandaloneSaleDialog
        open={openRaffleStandaloneModal}
        onClose={() => setOpenRaffleStandaloneModal(false)}
        storeId={store?._id}
        userId={currentUser?._id}
        cashRegisterId={cashRegister?._id}
        onSuccess={handleStandaloneRaffleSaleCreated}
        disabled={!isCashRegisterOpen || !hasActiveRaffle}
      />
      <Modal
        open={openReturnFlow}
        onClose={handleCloseReturnFlow}
        width='50%'
        Content={() => {
          const steps = ['Buscar producto', 'Historial', 'Confirmar']
          const activeStep = returnStep === 'search' ? 0 : returnStep === 'history' ? 1 : 2

          return (
            <Box display='flex' flexDirection='column'>
              {/* Header */}
              <Box
                display='flex'
                alignItems='center'
                justifyContent='space-between'
                px={2.5}
                py={1.5}
                sx={{ borderBottom: '1px solid', borderColor: 'divider', background: 'rgba(0,0,0,0.03)' }}
              >
                <Box display='flex' alignItems='center' gap={1}>
                  <AssignmentReturnOutlined sx={{ color: 'error.main', fontSize: 22 }} />
                  <Typography variant='subtitle1' fontWeight={700} color='error.main' letterSpacing={0.3}>
                    Devolución
                  </Typography>
                </Box>
                <IconButton size='small' onClick={handleCloseReturnFlow}>
                  <Close fontSize='small' />
                </IconButton>
              </Box>

              {/* Stepper */}
              <Box px={2.5} pt={2} pb={1}>
                <Stepper activeStep={activeStep} alternativeLabel>
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>

              <Divider />

              {/* Step content */}
              <Box px={2.5} py={2}>

                {/* STEP 1 - Search */}
                {returnStep === 'search' && (
                  <Box display='flex' flexDirection='column' gap={1.5}>
                    <Search onSearch={handleSearchReturnArticles} width='100%' />
                    {loadingReturnArticles && <CircularProgressCustom size={90} />}
                    {!loadingReturnArticles && returnArticles.length === 0 && (
                      <Typography variant='body2' color='text.secondary' textAlign='center' mt={1}>
                        Buscá un producto para ver el historial de ventas
                      </Typography>
                    )}
                    {!loadingReturnArticles && returnArticles.map((article) => {
                      const name = article?.name || article?.article?.name || 'Sin nombre'
                      const initials = name.slice(0, 2).toUpperCase()
                      return (
                        <Paper
                          key={article?.article_id || article?._id}
                          variant='outlined'
                          sx={{
                            display: 'flex', alignItems: 'center', gap: 1.5,
                            px: 2, py: 1.2, cursor: 'pointer', borderRadius: 2,
                            transition: 'all 0.15s',
                            '&:hover': { background: 'rgba(211,47,47,0.06)', borderColor: 'error.light' }
                          }}
                          onClick={() => handleSelectReturnArticle(article)}
                        >
                          <Avatar
                            sx={{ width: 36, height: 36, fontSize: 13, bgcolor: 'error.light', color: '#fff' }}
                          >{initials}</Avatar>
                          <Box flex={1}>
                            <Typography variant='body2' fontWeight={600}>{name}</Typography>
                            {article?.category && (
                              <Typography variant='caption' color='text.secondary'>
                                {typeof article.category === 'object' ? article.category?.name : article.category}
                              </Typography>
                            )}
                          </Box>
                          <Chip label='Ver historial' size='small' color='error' variant='outlined' clickable />
                        </Paper>
                      )
                    })}
                  </Box>
                )}

                {/* STEP 2 - History */}
                {returnStep === 'history' && (
                  <Box display='flex' flexDirection='column' gap={1.5}>
                    <Box
                      display='flex'
                      alignItems='center'
                      justifyContent='space-between'
                      sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 2,
                        backgroundColor: 'background.paper',
                        py: 0.5,
                      }}
                    >
                      <Box display='flex' alignItems='center' gap={1}>
                        <IconButton size='small' onClick={() => setReturnStep('search')}>
                          <ArrowBackIosNew sx={{ fontSize: 14 }} />
                        </IconButton>
                        <Typography variant='body2' color='text.secondary'>
                          {returnArticleSelected?.name || returnArticleSelected?.article?.name || 'Producto'}
                        </Typography>
                      </Box>
                      <IconButton size='small' onClick={handleCloseReturnFlow}>
                        <Close fontSize='small' />
                      </IconButton>
                    </Box>
                    <StockMovement
                      loading={loadingReturnMovements}
                      compras={returnMovements}
                      isHistorial
                      onReturn={handleSelectReturnFromHistory}
                    />
                    {returnMovementsHasMore && (
                      <Box display='flex' justifyContent='center'>
                        <Button
                          variant='outlined'
                          color='error'
                          onClick={handleLoadMoreReturnMovements}
                          disabled={loadingMoreReturnMovements}
                        >
                          {loadingMoreReturnMovements ? 'Cargando...' : 'Cargar más'}
                        </Button>
                      </Box>
                    )}
                  </Box>
                )}

                {/* STEP 3 - Confirm */}
                {returnStep === 'confirm' && (
                  <Box display='flex' flexDirection='column' gap={1.5}>
                    <Box display='flex' alignItems='center' gap={1}>
                      <IconButton size='small' onClick={() => { setReturnSaleSelected(null); setReturnStep('history') }}>
                        <ArrowBackIosNew sx={{ fontSize: 14 }} />
                      </IconButton>
                      <Typography variant='body2' color='text.secondary'>Volver al historial</Typography>
                    </Box>
                    <ReturnSale
                      sale={returnSaleSelected}
                      onSubmitReturnSale={handleSubmitReturnSale}
                      asCredit={returnAsCredit}
                      onToggleAsCredit={setReturnAsCredit}
                      onCancel={() => {
                        setReturnSaleSelected(null)
                        setReturnStep('history')
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          )
        }}
      />
      <Modal
        open={openStoreCreditsModal}
        onClose={() => setOpenStoreCreditsModal(false)}
        width='60%'
        Content={() => (
          <Box display='flex' flexDirection='column'>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='space-between'
              px={2.5}
              py={1.5}
              sx={{ borderBottom: '1px solid', borderColor: 'divider', background: 'rgba(0,0,0,0.03)' }}
            >
              <Box display='flex' alignItems='center' gap={1}>
                <ConfirmationNumberOutlined sx={{ color: 'secondary.main', fontSize: 22 }} />
                <Typography variant='subtitle1' fontWeight={700} color='secondary.main' letterSpacing={0.3}>
                  Vales
                </Typography>
              </Box>
              <IconButton size='small' onClick={() => setOpenStoreCreditsModal(false)}>
                <Close fontSize='small' />
              </IconButton>
            </Box>
            <StoreCreditsPanel storeId={store?._id} />
          </Box>
        )}
      />
      <CustomSnackbars
        show={!!returnCreditFeedback}
        message={returnCreditFeedback}
        onClose={() => setReturnCreditFeedback(null)}
      />
    </Box>
  );
}

export default Ventas;
